import { Conditions } from "utils/insight/conditions";
export class AssociationFactory {
    factory;
    associations;
    constructor(factory) {
        this.factory = factory;
    }
    getAssociation(...ids) {
        if (this.associations === undefined) {
            this.associations = this.getAllPairwiseAssociations();
        }
        switch (ids.length) {
            case 0:
            case 1:
                return 1;
            case 2:
                return this.associations[ids[0]][ids[1]];
            default:
                return NaN;
        }
    }
    _getAssociation(...ids) {
        switch (ids.length) {
            case 0:
            case 1:
                return 1;
            case 2:
                return this.getCramersV(ids[0], ids[1]);
            default:
                return NaN;
        }
    }
    getCramersV(idX, idY) {
        const global = this.factory.getSummary(Conditions.emptySet());
        if (global === undefined) {
            return NaN;
        }
        const x = this.factory.getSummarySet([idX]);
        const y = this.factory.getSummarySet([idY]);
        const xy = this.factory.getSummarySet([idX, idY]);
        let chi_squared = 0;
        for (const s of xy.getSummaries()) {
            const sx = x.getSummary(s.conditions);
            const sy = y.getSummary(s.conditions);
            if (sx === undefined || sy === undefined) {
                continue;
            }
            const expected = (sx.n * sy.n) / global.n;
            const diff = s.n - expected;
            if (expected != 0) {
                chi_squared += (diff * diff) / expected;
            }
        }
        const phi = chi_squared / global.n;
        const k = x.size(), r = y.size(), n = global.n;
        const k_1 = k - 1, r_1 = r - 1, n_1 = n - 1;
        const phi_c = Math.max(0, phi - (k_1 * r_1) / n_1);
        const k_c = k - (k_1 * k_1) / n_1;
        const r_c = r - (r_1 * r_1) / n_1;
        return Math.sqrt(phi_c / Math.min(k_c - 1, r_c - 1));
    }
    getAllPairwiseAssociations() {
        if (this.associations === undefined) {
            this.associations = this.calculateAllPairwiseAssociations();
        }
        return this.associations;
    }
    calculateAllPairwiseAssociations() {
        const ids = this.factory.getAllIds();
        const n = ids.length - 1 == ids[ids.length - 1] ? ids.length : Math.max.apply(null, ids) + 1;
        const associations = Array.from(Array(n), () => Array(n));
        for (let i = 0; i < n; i++) {
            associations[i][i] = 1;
            for (let j = i + 1; j < n; j++) {
                associations[i][j] = this._getAssociation(i, j);
                associations[j][i] = associations[i][j];
            }
        }
        return associations;
    }
}
